export type SessionType = 'chem_call' | 'coaching_session' | 'unconfirmed';

export function getSessionTypeLabel(sessionType: string | null | undefined): string {
  switch (sessionType) {
    case 'chem_call':
      return 'Chemistry Call';
    case 'coaching_session':
      return 'Coaching Session';
    case 'unconfirmed':
      return 'Unconfirmed';
    default:
      return 'Unconfirmed';
  }
}

export function formatCompactSessionDate(value?: string | null): string {
  if (!value) {
    return '';
  }

  const dateOnly = parseDateOnly(value);
  if (dateOnly) {
    const month = String(dateOnly.month).padStart(2, '0');
    const day = String(dateOnly.day).padStart(2, '0');
    return `${dateOnly.year}.${month}.${day}`;
  }
  if (isDateOnlyLike(value)) {
    return '';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}.${month}.${day}`;
}

export function formatReadableSessionDate(value?: string | null): string {
  if (!value) {
    return '';
  }

  const dateOnly = parseDateOnly(value);
  if (dateOnly) {
    return new Intl.DateTimeFormat(undefined, {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'UTC',
    }).format(new Date(Date.UTC(dateOnly.year, dateOnly.month - 1, dateOnly.day)));
  }
  if (isDateOnlyLike(value)) {
    return '';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  return date.toLocaleDateString(undefined, {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}

function isDateOnlyLike(value: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(value.trim());
}

function parseDateOnly(value: string): { year: number; month: number; day: number } | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
  if (!match) {
    return null;
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const utcDate = new Date(Date.UTC(year, month - 1, day));
  if (
    utcDate.getUTCFullYear() !== year ||
    utcDate.getUTCMonth() !== month - 1 ||
    utcDate.getUTCDate() !== day
  ) {
    return null;
  }
  return { year, month, day };
}
